export default __webpack_public_path__ + "static/media/1126.799b25bd.png";